/**
 * @generated SignedSource<<5937084ef35e59d9906640c9150d154a>>
 * @relayHash 15f7936034547bc129d53f9c6b14fba9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15f7936034547bc129d53f9c6b14fba9

import type { ConcreteRequest } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "%future added value";
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type IssueFieldUpdateOperation = "ADD" | "CLEAR" | "REMOVE" | "SET" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssueInput = {
  agentAssignment?: AgentAssignmentInput | null | undefined;
  assigneeIds?: ReadonlyArray<string> | null | undefined;
  assignees?: ReadonlyArray<AssigneeUpdateInput> | null | undefined;
  body?: string | null | undefined;
  bodyVersion?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  id: string;
  issueFieldUpdates?: ReadonlyArray<IssueFieldUpdateInput> | null | undefined;
  issueType?: IssueTypeUpdateInput | null | undefined;
  issueTypeId?: string | null | undefined;
  labelIds?: ReadonlyArray<string> | null | undefined;
  labels?: ReadonlyArray<LabelUpdateInput> | null | undefined;
  milestoneId?: string | null | undefined;
  projectIds?: ReadonlyArray<string> | null | undefined;
  projectV2Ids?: ReadonlyArray<string> | null | undefined;
  state?: IssueState | null | undefined;
  stateInput?: IssueStateUpdateInput | null | undefined;
  title?: string | null | undefined;
};
export type AgentAssignmentInput = {
  baseRef?: string | null | undefined;
  customAgent?: string | null | undefined;
  customInstructions?: string | null | undefined;
  model?: string | null | undefined;
  targetRepositoryId?: string | null | undefined;
};
export type AssigneeUpdateInput = {
  actorId: string;
  confidence?: IssueEventConfidenceLevel | null | undefined;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type IssueFieldUpdateInput = {
  fieldName: string;
  operation: IssueFieldUpdateOperation;
  value?: string | null | undefined;
};
export type IssueTypeUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  issueTypeId?: string | null | undefined;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type LabelUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  labelId: string;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type IssueStateUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  duplicateIssueId?: string | null | undefined;
  rationale?: string | null | undefined;
  stateReason?: IssueClosedStateReason | null | undefined;
  suggest?: boolean | null | undefined;
  value: IssueState;
};
export type updateIssueMilestoneRelayMutation$variables = {
  input: UpdateIssueInput;
};
export type updateIssueMilestoneRelayMutation$data = {
  readonly updateIssue: {
    readonly issue: {
      readonly id: string;
      readonly milestone: {
        readonly closed: boolean;
        readonly closedAt: string | null | undefined;
        readonly dueOn: string | null | undefined;
        readonly id: string;
        readonly progressPercentage: number;
        readonly title: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueMilestoneRelayMutation$rawResponse = {
  readonly updateIssue: {
    readonly issue: {
      readonly id: string;
      readonly milestone: {
        readonly closed: boolean;
        readonly closedAt: string | null | undefined;
        readonly dueOn: string | null | undefined;
        readonly id: string;
        readonly progressPercentage: number;
        readonly title: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueMilestoneRelayMutation = {
  rawResponse: updateIssueMilestoneRelayMutation$rawResponse;
  response: updateIssueMilestoneRelayMutation$data;
  variables: updateIssueMilestoneRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssuePayload",
    "kind": "LinkedField",
    "name": "updateIssue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Milestone",
            "kind": "LinkedField",
            "name": "milestone",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueMilestoneRelayMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "updateIssueMilestoneRelayMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "15f7936034547bc129d53f9c6b14fba9",
    "metadata": {},
    "name": "updateIssueMilestoneRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "253dc6aa9f06016bb138f16bb1697b39";

export default node;
